import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
} from '@mui/material';
import HeroSection from '../components/HeroSection';
import TrendingDestinations from '../components/TrendingDestinations';
import BestSellingPackages from '../components/BestSellingPackages';
import InquiryPage from '../components/InquiryPage';
import ExclusiveOffers from '../components/ExclusiveOffers';
import ExploreThemes from '../components/ExploreThemes';
import TravelSpecials from '../components/TravelSpecials';
import Features from '../components/Features';
import Testimonials from '../components/Testimonials';
import NewsletterSubscribe from '../components/NewsletterSubscribe';

const Home = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/tours?search=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <Box>
      {/* HERO SECTION */}
      <HeroSection
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onSearch={handleSearch}
        navigate={navigate}
      />

      {/* FEATURES */}
      <Features />

      {/* TRENDING DESTINATIONS */}
      <TrendingDestinations />

      {/* TRAVEL SPECIALS */}
      <TravelSpecials />

      {/* INQUIRY */}
      <InquiryPage />

      {/* EXPLORE THEMES */}
      <ExploreThemes />

      {/* BEST SELLING PACKAGES */}
      <BestSellingPackages />

      {/* EXCLUSIVE OFFERS */}
      <ExclusiveOffers />

      {/* TESTIMONIALS */}
      <Testimonials />

      {/* NEWSLETTER CTA */}
      <NewsletterSubscribe />
    </Box>
  );
};

export default Home;
